import Glide, {Autoplay, Breakpoints, Controls, Swipe} from "@glidejs/glide/dist/glide.modular.esm";

require('../../scss/app-cruise-details.scss');

import Application from "./application";
import DeckPlanBehaviour from "../behaviours/deck-plan-behaviour";
import PartialBehaviour from '../behaviours/partial-behaviour';
import ScrollToBehaviour from '../behaviours/scroll-to-behaviour';
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import FromPriceBehavior from "../behaviours/from-price-behaviour";
import CruiseMilesBehaviour from "../behaviours/cruise-miles-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import CountDown from "../jsx/count-down";
import Timeline from "../jsx/timeline/timeline";
import Gallery from "../jsx/gallery";
import SoloToggle from "../jsx/solo-toggle";
import ModalPartial from "../jsx/modal/modal-partial";
import ShortlistCount from '../jsx/shortlist/shortlist-count';
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import TruncateBehavior from "../behaviours/truncate-behaviour";
import ReadMoreBehaviour from "../behaviours/read-more-behaviour";
import CruiseDeals from "../jsx/cruise-deals";

let config = {};
config.behaviours = {
    'PartialBehaviour': new PartialBehaviour(),
    'ScrollToBehaviour': new ScrollToBehaviour(),
    'DeckPlanBehaviour': new DeckPlanBehaviour(),
    'HideShowBehaviour': new HideShowBehaviour(),
    'BackgroundImageBehaviour': new BackgroundImageBehaviour(),
    'StickyNavBehaviour': new StickyNavBehaviour(),
    'MobileMenuBehaviour': new MobileMenuBehavior(),
    'FromPriceBehaviour': new FromPriceBehavior(),
    'CruiseMilesBehaviour': new CruiseMilesBehaviour(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'EqualizeBehaviour': new EqualizeBehavior(),
    'AccordionBehaviour': new AccordionBehaviour(),
    'TruncateBehaviour': new TruncateBehavior(),
    'ReadMoreBehaviour': new ReadMoreBehaviour()
};
config.components = {
    'count-down': CountDown,
    'timeline': Timeline,
    'gallery': Gallery,
    'solo-toggle': SoloToggle,
    'modal-partial': ModalPartial,
    'shortlist-count': ShortlistCount,
    'shortlist-button': ShortlistButton,
    'cruise-deals': CruiseDeals
};

new Application(config);

window.glide = {};
if(document.querySelector('.review-slider')) {
        window.glide.reviewSlider =  new Glide('.review-slider', {autoplay: false, perView: 2, bound: true, breakpoints: { 740: { perView: 1}  }})
            .mount({Autoplay, Controls, Breakpoints, Swipe})
            .on('run.after', () => {
                window.lazy.update();
                for (let behaviour in window.dataAttrBehaviours) {
                    window.dataAttrBehaviours[behaviour].init();
                }
            });
    }